import { instancePath } from "@/lib/instance";
import { ApiError } from "@/lib/api";

export const mediaFileTypes = ["image/jpeg", "image/png", "image/gif", "image/webp", "image/avif", "video/mp4", "video/webm", "video/ogg", "video/quicktime"];

export async function uploadAttachment(projectId: string, file: File, signal: AbortSignal): Promise<{ url: string; name: string; content_type: string }> {
  const query = new URLSearchParams({ name: file.name });
  const response = await fetch(`${instancePath}/api/projects/${encodeURIComponent(projectId)}/attachments?${query}`, {
    method: "POST", body: file, credentials: "same-origin", signal,
    headers: { "Content-Type": file.type || "application/octet-stream" },
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({ code: "common.internal", message: response.statusText })) as { code: string; message: string };
    throw new ApiError(response.status, error.code, error.message);
  }
  return response.json();
}
